// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey           : "AIzaSyDISUOGXh6Xz1AMu-ynSCio3KHt7dG0YEY",
    authDomain       : "caapps-dev.firebaseapp.com",
    databaseURL      : "https: //caapps-dev.firebaseio.com",
    projectId        : "caapps-dev",
    storageBucket    : "caapps-dev.appspot.com",
    messagingSenderId: "959369457184"
  }
};



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/environments/environment.ts